// extracted by mini-css-extract-plugin
module.exports = {"header_account_top_container":"headerAccountTop_header_account_top_container__kZlym","seperator":"headerAccountTop_seperator__7FEj3"};